import {Component, EventEmitter, Input, Output} from '@angular/core';
import {User} from '../../../domain/user';
import {MatTableDataSource} from '@angular/material/table';

@Component({
    selector: 'app-user-table',
    templateUrl: './user-table.component.html',
    styleUrls: ['./user-table.component.css'],
    standalone: false
})
export class UserTableComponent {
  @Output() editUser: EventEmitter<User> = new EventEmitter()

  @Input('users')
  set users(value: User[]) {
    this._users = value;

    this.buildColumnList();

    if (this.dataSource === undefined) {
      this.dataSource = new MatTableDataSource(this._users);
    } else {
      this.dataSource.data = this._users;
    }
  }

  private _users: User[];

  displayedColumns = [];

  dataSource: MatTableDataSource<User>;

  private buildColumnList() {
    const columns = [];

    columns.push('Active', 'Name', 'Username', 'Type');

    this.displayedColumns = columns;
  }
}
